<template>
  <div class="row">
    <div class="col-6">
      <b-form-group label="Inmuebles" label-for="inmueble">
        <v-select
          input-id="inmueble"
          v-model="localUnitFilter"
          :options="unitOptions"
          multiple
          placeholder="Seleccionar inmuebles"
          label="label"
          append-to-body
          :reduce="(u) => u.value"
          :calculate-position="withPopper"
        />
      </b-form-group>
    </div>
    <div class="col-6">
      <b-form-group label="Empleados" label-for="users">
        <v-select
          input-id="users"
          v-model="localUserFilter"
          :options="userOptions"
          multiple
          placeholder="Seleccionar empleados"
          append-to-body
          :filter-by="filterUsers"
          :get-option-label="getUserLabel"
          :reduce="(u) => u.id"
          :calculate-position="withPopper"
        >
          <template v-slot:option="option">
            {{ option.soeid }} | {{ option.name }} {{ option.first_name }} {{ option.second_name }}
          </template>
        </v-select>
      </b-form-group>
    </div>
    <div class="col-6">
      <b-form-group label="Estatus" label-for="status">
        <v-select
          input-id="status"
          v-model="localStatusFilter"
          :options="statusOptions"
          multiple
          placeholder="Seleccionar estatus"
          label="label"
          append-to-body
          :reduce="(s) => s.value"
          :calculate-position="withPopper"
        />
      </b-form-group>
    </div>
    <div class="col-12 mb-1">
      Fecha de creación
    </div>
    <div class="col-6">
      <b-form-group label="Fecha inicio" label-for="start">
        <div class="input-group">
          <flat-pickr
            v-model="localStartDateFilter"
            class="form-control"
            placeholder="Seleccionar fecha inicio"
            :config="config"
          />
          <div class="input-group-append">
            <button
             type="button"
              class="btn btn-outline-primary"
              @click="localStartDateFilter = null"
            >
              x
            </button>
          </div>
        </div>
        <div v-if="startDateError" class="text-danger">
          {{ startDateError }}
        </div>
      </b-form-group>
    </div>
    <div class="col-6">
      <b-form-group label="Fecha fin" label-for="end">
        <div class="input-group">
          <flat-pickr
            v-model="localEndDateFilter"
            class="form-control"
            placeholder="Seleccionar fecha fin"
            :config="config"
          />
          <div class="input-group-append">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="localEndDateFilter = null"
            >
              x
            </button>
          </div>
        </div>
        <div v-if="endDateError" class="text-danger">
          {{ endDateError }}
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component';
import popperHelper from "@/libs/popper-helper";
import { computed,getCurrentInstance } from "@vue/composition-api";
import { Spanish } from 'flatpickr/dist/l10n/es.js';

export default {
  name: "CrisisFormFilters",
  components: {
    flatPickr,
    vSelect
  },
  props: {
    endDateFilter: {
      default: null
    },
    startDateFilter: {
      default: null
    },
    endDateError: {
      type: String,
      default: ''
    },
    startDateError: {
      type: String,
      default: ''
    },
    statusFilter: {
      type: Array,
      default: () => []
    },
    usersFilter: {
      type: Array,
      default: () => []
    },
    userOptions: {
      type: Array,
      default: () => []
    },
    unitOptions: {
      type: Array,
      default: () => []
    },
    unitFilter: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy;

    const statusOptions = [
      { label: vm.$t("risk.status_in_progress"), value: "in_progress" },
      { label: vm.$t("risk.status_in_review"), value: "review" },
      { label: vm.$t("risk.status_approved"), value: "completed" },
      { label: vm.$t("risk.status_rejected"), value: "rejected" },
      { label: vm.$t("risk.status_reassigned"), value: "reopened" }
    ];

    //COMPUTED
    const config = computed(() => ({
      locale: Spanish,
      maxDate: 'today',
      dateFormat: 'Y-m-d H:i:S',
      enableTime: true
    }));

    const localEndDateFilter = computed({
      get: () => props.endDateFilter,
      set: (value) => emit("update:endDateFilter", value)
    });

    const localStartDateFilter = computed({
      get: () => props.startDateFilter,
      set: (value) => emit("update:startDateFilter", value)
    });

    const localStatusFilter = computed({
      get: () => props.statusFilter,
      set: (value) => emit("update:statusFilter", value)
    });

    const localUnitFilter = computed({
      get: () => props.unitFilter,
      set: (value) => emit("update:unitFilter", value)
    });

    const localUserFilter = computed({
      get: () => props.usersFilter,
      set: (value) => emit("update:usersFilter", value)
    });

    //METHODS
    const filterUsers =(option, label, search) => {
      const text = search.toLowerCase();

      return (
        option.soeid?.toLowerCase().includes(text) ||
        option.name?.toLowerCase().includes(text) ||
        option.first_name?.toLowerCase().includes(text) ||
        option.second_name?.toLowerCase().includes(text)
      );
    }

    const getUserLabel = (option) => {
      return `${option.soeid} | ${option.name} ${option.first_name} ${option.second_name}`
    }

    return {
      statusOptions,
      withPopper: popperHelper.withPopper,

      config,
      localEndDateFilter,
      localStartDateFilter,
      localStatusFilter,
      localUnitFilter,
      localUserFilter,

      filterUsers,
      getUserLabel
    }
  }
}
</script>

<style lang="scss" scoped>
.filters-row {
  gap: 10px;
}

.filter-field {
  min-width: 230px;
  max-width: 100%;
}
</style>
